var map = {
	"./volatility_cn.png": "c233",
	"./volatility_en.png": "d1ab",
	"./volatility_id.png": "b872",
	"./volatility_ko.png": "e8f1",
	"./volatility_ph.png": "2914",
	"./volatility_th.png": "2355",
	"./volatility_zh.png": "8424"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3089";